import React, { useEffect, useState } from 'react';
import SlideToggle from '../../../../../../../../common/components/ui/toggleSwitch/SlideToggle';
import { formatCurrency } from '../../../../../../../../common/helpers/mask.helpers';
import InputMoney from '../../../../../../../../common/components/form/CurrencyInputFormik';

interface AditionalValuesCancelPlanProps {
  valueWeeks: number;
  dailyFine: number;
  finePlanValue: string;
  onTotalChange?: (values: {
    initalValue: number;
    amountValue: number;
    isCheckedRetraction: boolean;
    isCheckedCommandBlock: boolean;
    valuesSinister: number;
    isPostWeekChecked: boolean;
    isWeeklyLate: boolean;
  }) => void;
}

const AditionalValuesCancelPlan: React.FC<AditionalValuesCancelPlanProps> = ({ valueWeeks, finePlanValue, onTotalChange }) => {
  const [isPostWeekChecked, setPostWeekChecked] = useState(false);
  const [isWeeklyLate, setWeeklyLate] = useState(false);
  const [valueSinister, setValueSinister] = useState(0);
  const [isCheckedRetraction, setCheckedRetraction] = useState(false);
  const [isCheckedCommandBlock, setCheckedCommandBlock] = useState(false);

  let initalValue = parseFloat(finePlanValue);

  const additionalValuePostWeek = isPostWeekChecked ? valueWeeks : 0;
  const additionalValueWeeklyLate = isWeeklyLate ? valueWeeks : 0;
  const additionalValueSinister = 0;
  const additionalFine = isCheckedRetraction ? 200 : 0;
  const additionalValueCommandBlock = isCheckedCommandBlock ? 20 : 0;

  const amountValue = additionalValuePostWeek + additionalValueWeeklyLate + additionalFine + additionalValueCommandBlock + additionalValueSinister;

  if (amountValue > 0) {
    initalValue += amountValue;
  }

  useEffect(() => {
    if (onTotalChange) {
      onTotalChange({ initalValue, amountValue, isCheckedRetraction, isCheckedCommandBlock, valuesSinister: valueSinister, isPostWeekChecked, isWeeklyLate });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPostWeekChecked, isWeeklyLate, isCheckedCommandBlock, isCheckedRetraction, initalValue, amountValue]);

  return (
    <section>
      {/* Grid 2x2 */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mt-2">
        {/* Item 1 */}
        <div className="flex items-center">
          <label className="font-semibold text-[14px]">Semana Pós</label>
          <SlideToggle
            name="isPostWeekChecked"
            className="ml-2"
            onToggle={(checked) => setPostWeekChecked(checked)}
          />
          <span className="ml-2">{isPostWeekChecked ? "Sim" : "Não"}</span>
        </div>
        <div className="flex items-center">
          <label className="font-semibold text-[14px]">Semanal atrasada</label>
          <SlideToggle
            name="isWeeklyLate"
            className="ml-2"
            onToggle={(checked) => setWeeklyLate(checked)}
          />
          <span className="ml-2">{isWeeklyLate ? "Sim" : "Não"}</span>
        </div>

        {/* Item 2 */}
        <div className="flex items-center">
          <label className="font-semibold text-[14px]">bloqueio</label>
          <SlideToggle
            name="isCheckedCommandBlock"
            className="ml-2"
            onToggle={(checked) => setCheckedCommandBlock(checked)}
          />
          <span className="ml-2">{isCheckedCommandBlock ? "Sim" : "Não"}</span>
        </div>

        {/* Item 3 */}
        <div className="flex items-center">
          <label className="font-semibold text-[14px]">recolhimento</label>
          <SlideToggle
            name="isCheckedRetraction"
            className="ml-2"
            onToggle={(checked) => setCheckedRetraction(checked)}
          />
          <span className="ml-2">{isCheckedRetraction ? "Sim" : "Não"}</span>
        </div>

        {/* Item 4 */}
        {/* <div className="flex items-center">
          <label className="font-semibold text-[14px]">Danificação do veículo?</label>
          <SlideToggle
            name="isCheckedSinister"
            className="ml-2"
            onToggle={(checked) => {
              setCheckedSinister(checked);
            }}
          />
          <span className="ml-2">{isCheckedSinister ? "Sim" : "Não"}</span>
        </div> */}
      </div>

      {/* Campo de valor do sinistro (ocupa toda a largura quando ativo) */}
      {false && (
        <div className="mt-4">
          <InputMoney
            label="Digite o valor do sinistro para adicionar a multa"
            name="sinister"
            required={true}
            value={valueSinister}
            onValueChange={(newValue) => setValueSinister(newValue)}
          />
        </div>
      )}

      {/* Valor total */}
      <div className="mt-4">
        <p className="text-redPrimary text-sm font-semibold">
          Valor total calculado: R$ {formatCurrency(initalValue)}
        </p>
      </div>
    </section>
  );
};

export default AditionalValuesCancelPlan;